import { Component } from 'react'
import ModuleLazyLoaderService from '../../services/module-lazy-loader'
import UtilService from '../../services/util'

const refreshTimeout = (lazy) => {
    removeTimeout(lazy)
    const delay = 3 * 1000
    lazy.lazyComponentLoadTimeout = setTimeout(() => {
        UtilService.safeLog('LazyComponent did not render in a timely manner; did you forget to call loadModules?')
    }, delay)
}

const removeTimeout = (lazy) => {
    clearTimeout(lazy.lazyComponentLoadTimeout)
}

export default class LazyComponent extends Component {

    constructor(props) {
        super(props)
        this.lazyComponentLoadTimeout = null
        this.lazyComponentUnmounted = false
        this.modules = {}
        this.state = {
            LazyComponent: {
                modulesLoaded: false
            }
        }
    }

    componentWillUnmount() {
        removeTimeout(this)
        this.lazyComponentUnmounted = true
    }

    loadModules(modules, callback) {
        const modulesToLoad = []
        if (Array.isArray(modules)) {
            modulesToLoad.push.apply(modulesToLoad, modules)
        }
        else {
            modulesToLoad.push(modules)
        }

        const me = this
        ModuleLazyLoaderService.load(modulesToLoad)
            .then((modules) => {
                if (me.lazyComponentUnmounted) {
                    return
                }
                modulesToLoad.forEach((name) => {
                    me.modules[name] = modules[name]
                })
                if (callback) {
                    try {
                        callback()
                    }
                    catch(error) {
                        throw new Error('Lazy module load callback failed: ' + error)
                    }
                }
                me.setState({
                    LazyComponent: {
                        modulesLoaded: true
                    }
                })
            })
            .catch((error) => {
                throw(error)
            })
    }

    modulesLoaded() {
        const { LazyComponent } = this.state

        if (!LazyComponent) {
            UtilService.safeLog('LazyComponent\'s base state was overwritten; ' +
                'use Object.assign to initialize LazyComponent state')
        }

        return LazyComponent.modulesLoaded
    }

    lazySetState(promiseMap) {
        Object.keys(promiseMap).forEach((key) => {
            let promise = promiseMap[key]

            if (!promise || !promise.then) {
                const value = promise

                promise = new Promise((resolve) => {
                    resolve(value)
                })
            }

            promise.then((value) => {
                this.setState({
                    [key]: value
                })
            })
        })
    }

    lazyRender() {
        UtilService.safeLog('LazyComponent.lazyRender called; this is probably not what you intended')
        return null
    }

    render() {
        refreshTimeout(this)

        if (!this.modulesLoaded()) {
            return null
        }
        removeTimeout(this)
        try {
            return this.lazyRender()
        }
        catch (error) {
            UtilService.safeLog(error.stack)
        }
        return null
    }

}



// WEBPACK FOOTER //
// src/components/lazy-component/index.js